import { render, staticRenderFns } from "./firmManage.vue?vue&type=template&id=52baa1ca"
import script from "./firmManage.vue?vue&type=script&lang=js"
export * from "./firmManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports